<div class="tasks-tab-container">
  <div class="tasks-header">
    <div class="title-section">
      <div class="title-container">
        <div class="inner-tab-title">Pending Tasks ({{ totalCount }})</div>
      </div>
    </div>
    <div class="filter-buttons">
      <app-button
        buttonVariant="filter"
        buttonType="button"
        [active]="filtersApplied"
        (buttonClick)="toggleFilters()"
      >
        <img [src]="'shared-assets/icons/filter.png'" alt="Filter Icon" class="filter-icon" />
        <span>Filters</span>
        @if (filtersApplied) {
          <span class="clear-icon" (click)="clearFilters(); $event.stopPropagation()" title="Clear filters">
            <img src="shared-assets/icons/close.png" alt="Clear Icon" class="clear-icon" />
          </span>
        }
      </app-button>
      <app-pill-search
        [searchText]="searchText"
        placeholder="Search"
        (searchChange)="updateSearch($event)"
        [isDisabled]="isDisabled"
      ></app-pill-search>
    </div>
  </div>

  <div class="tasks-list">
    <!-- Loading state -->
    @if (loading) {
      <div class="loading-container">
        <app-loading-spinner size="large" label="Loading Tasks..."></app-loading-spinner>
      </div>
    }

    <!-- Error state -->
    @if (error && !loading) {
      <div class="error-container">
        <mat-icon>error</mat-icon>
        <p>{{ error }}</p>
        <app-button buttonVariant="retry-link" buttonType="button" (buttonClick)="refreshTasks()">Retry</app-button>
      </div>
    }

    <!-- Empty state -->
    @if (!error && !loading && !tasks.length) {
      <app-empty-state
        [image]="'shared-assets/images/noTransactions_transparent.png'"
        [title]="filtersApplied || !!searchText ? 'No Results Found ' : 'You are all up to date'"
        [filtersApplied]="filtersApplied"
        [searchText]="searchText"
      ></app-empty-state>
    }

    @if (!error && !loading) {
      <!-- Tasks list -->
      @for (task of tasks; track task.id) {
        <div
          class="task-card"
          (click)="onTaskClick(task)"
          [ngClass]="{
            selected: task.id === selectedTask?.id,
          }"
        >
          <div class="task-avatar" [ngClass]="getAvatarClass(task.type)">
            <div class="avatar-background">
              <div class="avatar-circle">
                <mat-icon class="avatar-icon">{{ getTaskIcon(task.type) }}</mat-icon>
              </div>
            </div>
          </div>

          <div class="task-content">
            @if (isDepositOrWithdrawalTask(task)) {
              <div class="task-title-split">
                <span class="title-part-1">{{ getFirstTitlePart(task.title) }}</span>
                <span class="title-part-2">{{ getSecondTitlePart(task.title) }}</span>
              </div>
            } @else {
              <div class="task-title">
                {{ task.title }}
              </div>
            }
            <div class="task-meta">
              <div class="task-name">
                <mat-icon class="meta-icon">person</mat-icon>
                <span class="assignee">{{ task.initiatedByDisplayName }}</span>
              </div>
              <div class="divider"></div>
              <span class="due-date">{{ task.createdDate | date : 'dd MMM, hh:mm:ss a' }}</span>
            </div>
          </div>

          <div class="task-right-content">
            <div class="task-assignee">
              {{ getAssignee(task) }}
            </div>

            @if (getWalletName(task); as walletName) {
              <div class="wallet-info">
                <span class="wallet-label">{{ walletName }}</span>
                @if (isSettlementApp && getRiskLevel(task); as riskLevel) {
                  <span
                    class="warning-icon"
                    [matTooltip]="riskLevel"
                    matTooltipPosition="above"
                    [ngClass]="'risk-' + riskLevel"
                  ></span>
                }
              </div>
            }
          </div>
        </div>
      }
    }
  </div>
</div>
